import { makeStyles } from "tss-react/mui"
import { useFormikContext } from "formik"
import { CreateOpeningHoursFormValues } from "./openingHoursTypes"
import { Box, DialogContent, Stack, Typography } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { FormikSwitch, FormikTimePicker } from "../../../../../../../shared/components/forms/Formik"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMoon } from "@fortawesome/pro-regular-svg-icons"
import { Button } from "../../../../../../office/admin/components/Button"

const useStyles = makeStyles()((theme) => ({
    dialogContent: {
        padding: "3rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    button: {
        margin: "2rem auto 0",
        padding: "1rem 2rem",
    },
    timeInput: {
        width: "10rem",
    },
    closedContainer: {
        display: "flex",
        width: "20.5rem",
        padding: ".5rem 0.75rem",
        gap: ".5rem",
        alignItems: "center",
        backgroundColor: theme.palette.tailwind.slate[50],
        color: theme.palette.tailwind.slate[400],
    },
    closedContainerText: {
        color: theme.palette.tailwind.slate[400],
    },
}))

export function OpeningHoursFormContent() {
    const { classes } = useStyles()
    const { values } = useFormikContext<CreateOpeningHoursFormValues>()

    return (
        <DialogContent className={classes.dialogContent}>
            <Stack direction="column" spacing="1.25rem">
                {Object.keys(values).map((day) => (
                    <Box key={day} display="flex" alignItems="center" justifyContent="space-between">
                        <Box>
                            <LocalizedEnum base="merchant-update-account-opening-hours-day" enumValue={day}>
                                <FormikSwitch labelPlacement="end" name={`${day}.isOpen`}>
                                    {day}
                                </FormikSwitch>
                            </LocalizedEnum>
                        </Box>
                        {values[day as keyof CreateOpeningHoursFormValues].isOpen ? (
                            <Box display="flex" gap=".5rem">
                                <LocalizedStrict
                                    id="merchant-update-account-opening-hours-dialog-closed-time-select-from"
                                    attrs={{ label: true }}
                                >
                                    <FormikTimePicker className={classes.timeInput} label="From" name={`${day}.open`} />
                                </LocalizedStrict>
                                <LocalizedStrict
                                    id="merchant-update-account-opening-hours-dialog-time-select-to"
                                    attrs={{ label: true }}
                                >
                                    <FormikTimePicker className={classes.timeInput} label="To" name={`${day}.close`} />
                                </LocalizedStrict>
                            </Box>
                        ) : (
                            <Box className={classes.closedContainer}>
                                <FontAwesomeIcon icon={faMoon} />
                                <LocalizedStrict id="merchant-update-account-opening-hours-dialog-closed">
                                    <Typography>Closed</Typography>
                                </LocalizedStrict>
                            </Box>
                        )}
                    </Box>
                ))}
            </Stack>
            <LocalizedStrict id="merchant-update-account-opening-hours-dialog-save-button">
                <Button fullWidth={false} type="submit" className={classes.button}>
                    Save
                </Button>
            </LocalizedStrict>
        </DialogContent>
    )
}
